import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { setSession, takeResume, useAuth } from "@/lib/auth";

export const GoogleReturn = () => {
  const done = useRef(false);
  useEffect(() => {
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m || done.current) return;
    done.current = true;
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    api.post("/auth/google", { sessionId: decodeURIComponent(m[1]) })
      .then(({ data }) => { setSession(data); toast(`Signed in as ${data.user.name}`); })
      .catch((e) => toast(errMsg(e, "Google sign-in failed. Try again.")));
  }, []);
  return null;
};

export function useResume(key, fn) {
  const auth = useAuth();
  const ran = useRef(false);
  useEffect(() => {
    if (auth && key && !ran.current && takeResume(key)) { ran.current = true; fn(); }
  }, [auth, key, fn]);
}
